import { Modal } from 'antd'
import Back from 'components/Icons/Back'
import Check from 'components/Icons/Check'
import Clock from 'components/Icons/Clock'

import IconClose from 'components/Icons/Close'
import Button from 'components/UI/Buttom'

import './styles.scss'
import { useAccessibility } from 'context/hooks/useAccessibility'

interface ModalContdownProps {
  visible: boolean
  countdown: number
  closeModal: () => void
  handleOk: () => void
  handleCancel: () => void
}

function ModalContdown({
  visible,
  closeModal,
  countdown,
  handleOk,
  handleCancel,
}: ModalContdownProps) {
  const { contrastIsSelected } = useAccessibility()

  return (
    <Modal
      className={`containerModalContdown ${
        contrastIsSelected ? 'contrastMode' : ''
      }`}
      visible={visible}
      onCancel={closeModal}
      closable={true}
      style={{ top: '25%' }}
      bodyStyle={{
        backgroundColor: contrastIsSelected
          ? 'var(--contrast-background-color)'
          : 'var(--background)',
        ...(contrastIsSelected && {
          color: contrastIsSelected
            ? 'var(--contrast-foreground-color)'
            : '#2D4040',
        }),
        boxShadow: 'var(--default-shadow)',
        borderRadius: '10px',
        padding: '0',
      }}
      closeIcon={
        <IconClose
          size="14px"
          color={
            contrastIsSelected
              ? 'var(--contrast-graphical-background-color)'
              : '#2D4040'
          }
        />
      }
      maskStyle={
        !contrastIsSelected
          ? { backgroundColor: 'rgba(45, 64, 64, 0.62)' }
          : { backgroundColor: 'var(--contrast-background-color)' }
      }
    >
      <div className="containerModalContdown__main">
        <Clock />
        <h1>Sua sessão irá expirar em breve</h1>
        <p>
          Sua conta será desconectada por inatividade em{' '}
          <span>{countdown} seg</span>. Você pode escolher “Continuar conectado”
          para extender sua sessão ou “Sair da conta” para desconectar agora.
        </p>
        <hr />
        <div className="containerModalContdown__main--buttons">
          <Button
            title="Sair da conta"
            icon={<Back />}
            onClick={handleCancel}
          />
          <Button
            title="Continuar conectado"
            type="primary"
            icon={<Check />}
            onClick={handleOk}
          />
        </div>
      </div>
    </Modal>
  )
}
/* 
Bloco -> Elemento -> Modificador
bloco-principal -> bloco-principal__ELEMENTO ->bloco-principal__ELEMENTO--modificador  */
export default ModalContdown
